import React from "react";
import LoaderElement from "../LoaderElement";

export default function LoaderNavItem(): JSX.Element {
  return <LoaderElement width={90} height={18} />;
}
